import React, { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

// Redux slices
import { maximizeSection, minimizeSection, stickSection, setContractIsLoaded, setContractData, startEdit, abortEdit, confimEdit, setContractSeasons } from './contractSlice'
import { setActivePage, setUser, setToken } from '../../appSlice';
import { setSubPage, setSubPage2 } from '../menu/menuSlice';

// Components
import AjaxController from '../system/ajaxController';
import Max2ContractBasicdata from './basicdata';
import Max2ContractSeasonRooms from './seasonrooms';
import Max2ContractSpecials from './specials';
import Max2ContractHeadOffice from './headoffice';
import Max2ContractComments from './comments';
import Max2ContractSeasonRoomsSticky from './seasonrooms_sticky';

/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

// SemanticUI components
import { Segment, Icon, Grid, GridRow, GridColumn, Label, Header, HeaderContent } from 'semantic-ui-react';

// Styles
import './contract.css';



/**
 * 
 * @returns 
 */
const Max2Contract = () => {
  // local state
  const [isSearching, setIsSearching] = useState(false);

  // global state
  const dispatch = useDispatch();
  const backendUrl    = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);
  const stateSections = useSelector((state) => state.contract.sections);
  const isLoaded      = useSelector((state) => state.contract.isLoaded);
  const contractId    = useSelector((state) => state.app.contractId);
  const Contract      = useSelector((state) => state.contract.data.Contract);
  const dataChanges = useSelector((state) => state.contract.data.Changes);

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();

  // 
  const availableSections = [
    { key: 'Basicdata',   header: 'Basisdaten',                     sticky: false, editMode: true,  content: <Max2ContractBasicdata editMode={stateSections.Basicdata.edit ? true : false }/> },
    { key: 'SeasonRooms', header: 'Saison/Zimmer/Verpflegungen',    sticky: true,  editMode: true,  content: <Max2ContractSeasonRooms editMode={stateSections.SeasonRooms.edit ? true : false }/> },
    { key: 'Specials',    header: 'Vertragspecials',                sticky: false, editMode: true,  content: <Max2ContractSpecials editMode={stateSections.Specials.edit ? true : false } type='Contract' />  },
    { key: 'AddSpecials', header: 'Specials',                       sticky: false, editMode: true,  content: <Max2ContractSpecials editMode={stateSections.AddSpecials.edit ? true : false } type='Additional' />  },
    { key: 'HeadOffice',  header: 'Aufenthalte/Anreisen/StopSale',  sticky: false, editMode: true,  content: <Max2ContractHeadOffice editMode={stateSections.HeadOffice.edit ? true : false }/>  },
    { key: 'Comments',    header: 'Bemerkungen',                    sticky: false, editMode: false, content: <Max2ContractComments /> }
  ];
  let sections = {};
  let sectionsMinimized = [];
  
  // Readonly when contract is locked
  const readonly = Contract?.Status?.STATUS === '33' ? true : false;



  /**
   *  
   * @param {string} section 
   * @returns
   * 
   */
  const handleEditModeClick = async (section) => {

    // init AJAX controller
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    // set new lock
    let response;
    try {
      response = await api.put('/contract/'+contractId+'/lock');
      if (response.status === 'error' && typeof response.lock !== 'undefined') {
        const min_remaining = Math.ceil(response.lock.time_remaining / 60);
        enqueueSnackbar('Objekt wird gerade bearbeitet von ' + response.lock.uname + ' ('+min_remaining+' min)', { variant: 'error' });
        return;
      }

      // start edit mode
      if (response.status === 'success') {
        dispatch(startEdit(section));
      }
    } catch (error) {
      enqueueSnackbar('Fehler beim Setzen der Zugangssperre.', { variant: 'error' });
      return;
    }
  }



  /**
   * Remove lock function
   * 
   * @async 
   */
  const removeLock = async () => {
    // init AJAX controller
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    // remove lock
    let response;
    try {
      response = await api.delete('/contract/'+contractId+'/unlock');
      if (response.status !== 'success') {
        enqueueSnackbar('Fehler beim widerrufen der Zugangssperre', { variant: 'error' });
        return;
      }
    } catch (error) {
      enqueueSnackbar('Fehler beim widerrufen der Zugangssperre', { variant: 'error' });
      return;
    }
  }



  /**
   * 
   * @param {string} section 
   */
  const handleAbortEditModeClick = (section) => {
    if (dataChanges.length === 0) {
      removeLock();
    }

    dispatch(abortEdit(section))
  }



  /**
   * 
   * @param {string} section 
   */
  const handleConfirmEditModeClick = (section) => {
    dispatch(confimEdit(section));
  }



  // Templates for expanded sections
  availableSections.forEach((sectionConfig) => {
    const editModeSection   = stateSections[sectionConfig.key].edit;
    const disabledSection   = stateSections[sectionConfig.key].disabled;
    const maximizedSection  = stateSections[sectionConfig.key].maximized;
    const segmentStyles     = disabledSection ? { margin: '25px', opacity: '0.2' } : { margin: '20px' };

    if (!maximizedSection) {
      sections[sectionConfig.key] = <></>;
    } else {
      sections[sectionConfig.key] = (
        <Segment key={sectionConfig.key} textAlign='left' style={segmentStyles}>
          <Label circular style={{marginBottom: '20px', background: 'transparent'}}><span style={{fontSize: '1.4em', margin: '10px'}}>{sectionConfig.header}</span></Label>
          <div style={{position: 'absolute', top: '5px', right: '5px'}}>
            {sectionConfig.key !== 'Masterdata' && (<Icon link size='large' name='window minimize'  onClick={()=>{ dispatch(minimizeSection(sectionConfig.key)) }} />)}
            {sectionConfig.sticky && (<Icon link size='large' name='pin'  onClick={()=>{ dispatch(stickSection(sectionConfig.key)) }} />)}
            {sectionConfig.editMode && editModeSection && 
              <>
              <Icon link size='large' name='times' onClick={()=>handleAbortEditModeClick(sectionConfig.key)} />
              <Icon link size='large' color='green' name='check' onClick={()=>handleConfirmEditModeClick(sectionConfig.key)} />
              </>
            }
            {sectionConfig.editMode && !editModeSection && !disabledSection && !readonly &&
              <Icon link size='large' name='edit' onClick={()=>handleEditModeClick(sectionConfig.key)} />
            }
            {!editModeSection && disabledSection && 
              <></>
            }
          </div>
          {sectionConfig.content}
        </Segment>
      );
    }
  })

  // Templates for minimized sections
  availableSections.forEach((sectionConfig) => {
    const maximizedSection  = stateSections[sectionConfig.key].maximized;

    if (!maximizedSection) {
      sectionsMinimized.push(<Label circular as='a' size='big' key={sectionConfig.key} style={{backgroundColor: 'rgb(255 255 255)'}} onClick={()=>dispatch(maximizeSection(sectionConfig.key))}>&nbsp;&nbsp;{sectionConfig.header}<Icon name='window maximize' style={{marginLeft: '15px'}}/></Label>);
    }
  })

  //
  const style =  stateSections.SeasonRooms.sticky ? {height: 'calc(100vh - 190px)', overflow: 'scroll', width: '99% !important'} : {height: 'calc(100vh - 75px)', overflow: 'scroll', width: '99% !important'};

  
  
  /**
   * Load contract details from backend
   * @description This function fetches the contract details from the backend using the provided contract ID.
   * It initializes the contract data in the Redux store and updates the active page and sub-pages accordingly.
   * 
   * @param {integer} contractId 
   */
  const loadContractDetails = useCallback(async (contractId) => {
    try {
      // Controller for AJAX requests
      const api = new AjaxController(backendUrl, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
          });

      // show loading animation
      setIsSearching(true);

      // send search request
      const response = await api.get('/contract/' + contractId);
      
      // display details
      if (response?.Contract) {
        dispatch(setContractData({ target: 'ALL', value: response.Contract }));
        dispatch(setSubPage(response.Contract.Basics.Hotelcode));
        dispatch(setSubPage2('Vertrag ' + response.Contract.Basics.Season.text));
      }

      // contract siblings
      if (response?.Meta?.allSeasons) {
        dispatch(setContractSeasons(response?.Meta?.allSeasons));
      }

      // hide loading animation
      dispatch(setContractIsLoaded(true));
      setIsSearching(false);

    } catch (err) {
      //setError(err.message);
      console.error(err.message);
      //setIsSearching(false);
    }
  }, [backendUrl, dispatch]);



  /**
   * Initialize contract data
   */
  useEffect(() => {
    if (!isLoaded) {
      loadContractDetails(contractId);
    }
  }, [contractId, isLoaded, loadContractDetails]);


  
  // Show placeholder while getting data 
  if (isSearching) {
    return (
      <Segment textAlign='left' style={{margin: '25px'}}>
        <Header as='h2' textAlign='center'>
          <Icon loading name='spinner' />
          <HeaderContent>
            Daten werden geladen
          </HeaderContent>
        </Header>
      </Segment>
    )
  }

  //
  if (!isLoaded) {
    return <></>
  }

  //
  return (
    <Grid>
      {stateSections.SeasonRooms.sticky && (
        <GridRow columns={1}>
          <GridColumn>
            <Max2ContractSeasonRoomsSticky />
          </GridColumn>
        </GridRow>
      )}
      <GridRow columns={1}>
        <GridColumn>{sectionsMinimized.map((section)=>{ return section; })}</GridColumn>
      </GridRow>
        <GridRow columns={1} style={style}>
          <GridColumn>
            {sections.Basicdata}
            {sections.SeasonRooms}
            {sections.Specials}
            {sections.AddSpecials}
            {sections.HeadOffice}
            {sections.Comments}
          </GridColumn>
        </GridRow>
    </Grid>
  );
}

export default Max2Contract;
